/*
 *   File : slider.js
 *   Author : https://evoqins.com
 *   Description : Custom slider component
 *   Integrations : react-slider
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import ReactSlider from "react-slider";

const CustomSlider = (props) => {

    const [sliderValue, setSliderValue] = useState(props.defaultValue);

    useEffect(() => {
        setSliderValue(props.defaultValue);
    }, [props.defaultValue]);

    // slider change function
    function _handleSliderChange(value) {
        setSliderValue(value);
        props.handleChange(value);
    }

    // slider track click function
    function _handleSliderClick(value) {
        setSliderValue(value);
        props.handleChange(value);
    }

    // rendering custom track
    function Track(props) {
        return (
            <div {...props}></div>
        )
    }

    // rendering custom thumb
    function Thumb(props) {
        return (
            <div {...props}></div>
        )
    }

    // Type 2 uses the white pill thumb image and a blue filled track
    const thumbClassName = props.type === 2 ?
        "slider-thumb-2 cursor-pointer"
        :
        "w-12px h-12 e-border-radius-50per e-outline-4px-egyptian_blue_opacity-14  top-neg-4px cursor-pointer e-bg-egyptian-blue";

    const trackClassName = props.type === 2 ?
        "cursor-pointer h-4 e-border-radius-8 slider-track-type-2"
        :
        "cursor-pointer h-4 e-border-radius-8 e-bg-lavender-blue-40 slider-track";

    return (
        <ReactSlider
            value={sliderValue}
            max={props.max}
            min={props.min}
            step={props.step}
            thumbClassName={thumbClassName}
            trackClassName={trackClassName}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={_handleSliderChange}
            onSliderClick={_handleSliderClick} />
    )
};

export default CustomSlider